import { useState, useEffect, useRef } from "react";
import "./styles.css";
import Papa from "papaparse";
import logo from "./Logo3.png";
import { Link } from "react-router-dom";
//import { SpeedInsights } from "@vercel/speed-insights/react"
//import { Analytics } from "@vercel/analytics/react"

/**
 * Componente principal del juego InazumaDle
 */
function InazumaDle() {
  const [personajes, setPersonajes] = useState([]); 
  const [personajeActual, setPersonajeActual] = useState(null); 
  const [input, setInput] = useState(""); 
  const [sugerencias, setSugerencias] = useState([]); 
  const [historial, setHistorial] = useState([]); 
  const [mensaje, setMensaje] = useState(""); 
  const [intentosPrevios, setIntentosPrevios] = useState(new Set()); 
  const [partidaTerminada, setPartidaTerminada] = useState(false); 
  const [pistaEquipo, setPistaEquipo] = useState(null); 
  const [pistaMostrada, setPistaMostrada] = useState(false); // Para controlar si ya se mostró la pista
  const [celdasAnimadas, setCeldasAnimadas] = useState([]); 
  const [animacionesCompletadas, setAnimacionesCompletadas] = useState(new Set()); 
  const [celdasVisibles, setCeldasVisibles] = useState(new Set()); 
  const [showConfetti, setShowConfetti] = useState(false);
  const [trophies, setTrophies] = useState([]);
  const animationRef = useRef();
  const [showVictory, setShowVictory] = useState(false);
  const [countdown, setCountdown] = useState("");
  const [attempts, setAttempts] = useState(() => {
    const savedAttempts = localStorage.getItem('inazumadle_hissatsu_attempts');
    return savedAttempts ? parseInt(savedAttempts) : 0;
  });
  const [winStreak, setWinStreak] = useState(() => {
    // Asegurar que la racha se carga al iniciar
    const savedStreak = localStorage.getItem('inazumadle_hissatsu_winStreak');
    return savedStreak ? parseInt(savedStreak) : 0;
  });
  const [useJapanese, setUseJapanese] = useState(() => {
  const savedLanguage = localStorage.getItem('inazumadle_languagePreference');
  return savedLanguage || 'english'; // 'english', 'japanese', 'spanish', 'french'
});


  const [record, setRecord] = useState(() => {
    const savedRecord = localStorage.getItem('inazumadle_hissatsu_record');
    return savedRecord ? parseInt(savedRecord) : 0;
  });



const physics = {
  gravity: 0.5,
  friction: 0.98,
  terminalVelocity: 15
};

const limpiarCacheAntigua = () => {
  const hoy = new Date();
  const ayer = new Date(hoy);
  ayer.setDate(ayer.getDate() - 1); // Restar 1 día para obtener ayer

  // Formatear fechas en CET (Europe/Madrid)
  const formatoCET = (fecha) => 
    fecha.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" })
      .replace(/\//g, '-');

  const claveHoy = `inazumadle_hissatsu_${formatoCET(hoy)}`;
  const claveAyer = `inazumadle_hissatsu_${formatoCET(ayer)}`;

  // Expresión regular para detectar claves con fecha (inazumadle_MM-DD-YYYY)
  const regexFecha = /^inazumadle_hissatsu_(\d{1,2})-(\d{1,2})-(\d{4})$/;

  Object.keys(localStorage).forEach(key => {
    if (regexFecha.test(key) && key !== claveHoy && key !== claveAyer) {
      localStorage.removeItem(key); // Borra solo registros antiguos (excepto hoy/ayer)
    }
  });
};

  // Referencias para el input y el menú desplegable
  const inputRef = useRef(null);
  const menuRef = useRef(null);

  // Nuevo ref para el contenedor de victoria
  const victoryRef = useRef(null);

  const calculateDayNumber = () => {
  const startDate = new Date('2025-07-15');
  const today = new Date();
  const timeDiff = today - startDate;
  const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  return dayDiff + 1; // Sumamos 1 para que el primer día sea #1
};

const generateEmojiGrid = () => {
  const emojiRows = [];
  const maxAttempts = 8; // Número máximo de intentos a mostrar
  
  for (let i = 0; i < Math.min(attempts, maxAttempts); i++) {
    const attempt = historial[i];
    let emojiRow = "";
    
    if (attempt) {
      attempt.forEach((cell, j) => {
        if (j >= 7) return; // Solo mostramos las primeras 8 columnas
        
        if (cell.color === "green") {
          emojiRow += "🟩";
        } else if (cell.color === "#c0710a") {
          emojiRow += "🟧";
        } else {
          emojiRow += "🟥";
        }
      });
    } else if (i === attempts - 1) {
      // Fila del acierto (todas verdes)
      emojiRow = "🟩".repeat(8);
    } else {
      // Filas no intentadas
      emojiRow = "⬜".repeat(8);
    }
    
    emojiRows.push(emojiRow);
  }
  
  // Añadir indicador si hay más filas no mostradas
  if (attempts > maxAttempts) {
    emojiRows.push(`+ ${attempts - maxAttempts} more rows!`);
  }
  
  return emojiRows.join("\n");
};

const t = (en, es, fr) => {
  if (useJapanese === 'spanish') return es;
  if (useJapanese === 'french') return fr || en;
  return en;
};

const generateTweetMessage = () => {
  const dayNumber = calculateDayNumber();
  const emojiGrid = generateEmojiGrid();
  const playerName = useJapanese && personajeActual['Japanese Name'] ? 
    personajeActual['Japanese Name'] : personajeActual.Name;
  
  return `I just guessed today's hissatsu in Inazumadle Hissatsu Mode #${dayNumber} in ${attempts} tries! #InazumaDle 🎉⚽\n\n${emojiGrid}\n\nhttps://www.inazumadle.com/`;
};

  useEffect(() => {
  localStorage.setItem('inazumadle_languagePreference', useJapanese);
}, [useJapanese]);

  // Modificado para hacer scroll al mensaje de victoria
  useEffect(() => {
    if (showVictory && victoryRef.current) { // Verifica que el elemento exista
      const timer = setTimeout(() => {
        if (victoryRef.current) { // Doble verificación por si cambió de página
          victoryRef.current.scrollIntoView({ 
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      }, 1000);
      
      return () => clearTimeout(timer); // Limpia el timer al desmontar
    }
  }, [showVictory]);

  useEffect(() => {
    if (winStreak > record) {
      const newRecord = winStreak;
      setRecord(newRecord);
      localStorage.setItem('inazumadle_hissatsu_record', newRecord.toString());
    }
  }, [winStreak, record]);

  const startCountdown = () => {
    const updateCountdown = () => {
      const now = new Date();
      // Ajuste clave: Usamos UTC y luego convertimos a CET
      //Note: hello
      const cetTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Madrid" }));
      const midnight = new Date(cetTime);
      midnight.setHours(24, 0, 0, 0); // Medianoche CET (00:00)
      
      const diff = midnight - cetTime;
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setCountdown(`${hours}h ${minutes}m ${seconds}s`);
    };
  
    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  };

  // Función para generar una clave única basada en la fecha
const getStorageKey = () => {
  const hoy = new Date();
  const fechaCET = hoy.toLocaleString("en-US", { timeZone: "Europe/Madrid" }).split(',')[0];
  return `inazumadle_hissatsu_${fechaCET.replace(/\//g, '-')}`;
};

const loadGameState = () => {

  const key = getStorageKey();
  const savedState = localStorage.getItem(key);
  return savedState ? JSON.parse(savedState) : null;

};

const claves = [
  "Hissatsu", "Name", "Team", "Position", "Element", "TP", "First Appear"
];


// Función para guardar el estado
const saveGameState = (state) => {
  const key = getStorageKey();
  
  const cleanedHistorial = state.historial.map(intento =>
  intento.map(cell => ({
    key: cell.key,
    valor: cell.valor || "",
    color: cell.color || '#7a1919',
    arrow: cell.arrow || null
  }))
);


  // Limpiar también celdasVisibles para que coincida con 8 columnas
  const cleanedCeldasVisibles = new Set();
  cleanedHistorial.forEach((_, filaIndex) => {
    for (let i = 0; i < 8; i++) {
      cleanedCeldasVisibles.add(`${filaIndex}-${i}`);
    }
  });
  
  localStorage.setItem(key, JSON.stringify({
    ...state,
    celdasVisibles: Array.from(cleanedCeldasVisibles),
    useJapanese
  }));
  const stateToSave = {
    ...state,
    historial: cleanedHistorial,
    personajeActual: {
      ...state.personajeActual,
    }
  };

  localStorage.setItem(key, JSON.stringify(stateToSave));
};

  // Efecto para manejar clicks fuera del input y menú desplegable
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setSugerencias([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Carga inicial de datos desde el archivo CSV
  useEffect(() => {
    limpiarCacheAntigua();
    fetch(`${process.env.PUBLIC_URL || ""}/Hissatsu.csv?v=3.0`)
    .then(response => response.text())
      .then(csvText => {
        Papa.parse(csvText, {
          header: true,
          complete: (result) => {
            const personajesData = result.data.filter(p => p.Name && p.Hissatsu);
            setPersonajes(personajesData);
            // Cargar estado guardado si existe
            const savedState = loadGameState();
            if (savedState) {
              const cleanedHistorial = savedState.historial.map(intento => 
                intento.filter(caract => 
                  ["Hissatsu", "Name", "Team", "Position", "Element","TP", "First Appear"].includes(caract.key)
                )
              );
              setPersonajeActual(savedState.personajeActual);
              setHistorial(cleanedHistorial);
              setIntentosPrevios(new Set(savedState.intentosPrevios));
              setPartidaTerminada(savedState.partidaTerminada);
              setPistaEquipo(savedState.pistaEquipo);
              setPistaMostrada(savedState.pistaMostrada || false);
              if (typeof savedState.useJapanese === "boolean") {
                setUseJapanese(savedState.useJapanese);
              }
              const savedStreak = localStorage.getItem('inazumadle_hissatsu_winStreak');
              setWinStreak(savedStreak ? parseInt(savedStreak) : 0);
              // Forzar visibilidad de TODAS las celdas de los intentos guardados
              const nuevasVisibles = new Set();
              cleanedHistorial.forEach((_, filaIndex) => {
                for (let i = 0; i < 7; i++) { // ← 7 columnas (no 9)
                  nuevasVisibles.add(`${filaIndex}-${i}`);
                }
              });
              setCeldasVisibles(nuevasVisibles);
              
              if (savedState.partidaTerminada) {
                setShowVictory(true);
                setAttempts(savedState.historial.length);
                startCountdown();
              }
              saveGameState({
              ...savedState,
              personajeActual: savedState.personajeActual,
              historial: savedState.historial,
              celdasVisibles: nuevasVisibles
            });
            } else {
              seleccionarPersonajeDelDia(result.data);
            }
          }
        });
      });
  }, []);

  useEffect(() => {
    if (personajes.length > 0 && personajeActual) {
      const stateToSave = {
        personajeActual,
        historial,
        intentosPrevios: Array.from(intentosPrevios),
        partidaTerminada,
        pistaEquipo,
        pistaMostrada,
        celdasVisibles: Array.from(celdasVisibles)
      };
      saveGameState(stateToSave);
    }
  }, [historial, intentosPrevios, partidaTerminada, pistaEquipo, celdasVisibles, personajeActual, personajes]);

  useEffect(() => {
    if (showVictory) {
      const cleanup = startCountdown();
      return cleanup; // Esto limpiará el intervalo cuando el componente se desmonte
    }
  }, [showVictory]);

  // Reemplaza la función seleccionarPersonaje con esta versión mejorada
  const seleccionarPersonajeDelDia = (lista) => {
    const personajesValidos = lista.filter(p => p.Name && p.Name.trim() !== '');
    const hoy = new Date();
    const hoyCET = hoy.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" });
    const ayer = new Date(hoy);
    ayer.setDate(ayer.getDate() - 1);
    const ayerCET = ayer.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" });

    // 1. Mejor generación de semilla
    const semillaFecha = hashStringToInt(hoyCET);
    const semillaFija = 12345; // Puedes cambiar este valor por otro número primo
    const semillaExtra = hashStringToInt("INAZUMA_ELEVEN_" + hoyCET); // Texto único
    
    // Combinación más robusta de semillas usando XOR y multiplicación
    const semillaCombinada = (semillaFecha ^ semillaFija ^ semillaExtra) * 0x10001;

    // 2. Mejor algoritmo de selección aleatoria
    const randomIndex = robustSeededRandom(semillaCombinada, personajesValidos.length);
    const personajeDelDia = personajesValidos[randomIndex];
    setPersonajeActual(personajeDelDia);

    // 3. Lógica de win streak y gestión diaria
    const lastPlayedDate = localStorage.getItem('inazumadle_hissatsu_lastPlayedDate');
    const savedGameState = loadGameState();

    if (lastPlayedDate !== hoyCET) {
        // Es un nuevo día
        localStorage.setItem('inazumadle_hissatsu_lastPlayedDate', hoyCET);
        localStorage.setItem('inazumadle_hissatsu_attempts', '0'); // Resetear intentos
        setAttempts(0);

        // Verificar si ayer se completó la partida
        const ayerKey = `inazumadle_hissatsu_${ayerCET.replace(/\//g, '-')}`;
        const partidaAyer = JSON.parse(localStorage.getItem(ayerKey));

        if (!partidaAyer?.partidaTerminada) {
            // Reiniciar racha solo si ayer no se completó la partida
            setWinStreak(0);
            localStorage.setItem('inazumadle_hissatsu_winStreak', '0');
        }

        // Limpiar datos del día anterior
        localStorage.removeItem(ayerKey);
    }

    return personajeDelDia;
};

function hashStringToInt(str) {
    let hash = 5381; // Número primo inicial
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) + hash) + char; // hash * 33 + char
    }
    return hash >>> 0; // Asegura que sea un entero sin signo de 32 bits
}

// Algoritmo aleatorio más robusto (Mulberry32)
function robustSeededRandom(seed, max) {
    let t = seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) % max;
}

  /**
   * Maneja el cambio en el input de búsqueda y muestra sugerencias.
   * @param {Object} e - Evento del input
   */
  const handleInputChange = (e) => {
  if (partidaTerminada) return;

  const valor = e.target.value;
  setInput(valor);

  if (valor.length === 0) {
    setSugerencias([]);
    return;
  }

  const valorLower = valor.toLowerCase();

  
  const mostrarNombre = (p) => {
    if (useJapanese === 'japanese') return p["Japanese Name"] || p.Name;
    if (useJapanese === 'spanish') return p["Spanish Name"];
    if (useJapanese === 'french') return p["Frances Name"];
    return p.Name;
  };

  const mostrarEquipo = (p) => {
    if (useJapanese === 'japanese') return p["Japanese Team"] || p.Team;
    if (useJapanese === 'spanish') return p["Spanish Team"] || p.Team;
    if (useJapanese === 'french') return p["Frances Team"] || p.Team;
    return p.Team;
  };

  const yaIntentado = (p) => intentosPrevios.has(p.Hissatsu);

  let sugerenciasFinales = [];

  personajes.forEach(p => {
    const mostrarHissatsu = (p) => {
      if (useJapanese === 'japanese') return p["Japanese Hissatsu"] || p.Hissatsu;
      if (useJapanese === 'spanish') return p["Spanish Hissatsu"] || p.Hissatsu;
      if (useJapanese === 'french') return p["Frances Hissatsu"] || p.Hissatsu;
      return p.Hissatsu;
    };
    const hissatsuNombre = mostrarHissatsu(p)?.toLowerCase();
    const nombreVisible = mostrarNombre(p).toLowerCase();
    const equipoVisible = mostrarEquipo(p).toLowerCase();

    const matchHissatsu = hissatsuNombre?.includes(valorLower);
    const matchNombre = nombreVisible.includes(valorLower);
    const matchEquipo = equipoVisible.split("/").some(eq => eq.trim().includes(valorLower));

    if ((matchHissatsu || matchNombre || matchEquipo) && !yaIntentado(p)) {
      const hissatsuOriginal = p.Hissatsu;
      const hissatsuVisible = mostrarHissatsu(p);

      sugerenciasFinales.push({
        name: hissatsuVisible,
        originalName: hissatsuOriginal,
        image: `/images/hissatsu/${hissatsuOriginal.toLowerCase().replace(/ /g, "-")}.png`,
        type: 'hissatsu'
      });
    }
  });

  setSugerencias(sugerenciasFinales.slice(0, 50)); // Límite de sugerencias
};


  /**
   * Selecciona una sugerencia del menú desplegable.
   * @param {string} nombre - Nombre del personaje seleccionado
   */
  const seleccionarSugerencia = (nombreHissatsu) => {
    setInput(nombreHissatsu);
    setSugerencias([]);
    handleGuess(nombreHissatsu);
  };

  const gameOrder = {
  "Inazuma Eleven 1": 1,
  "Inazuma Eleven 2": 2,
  "Inazuma Eleven 3": 3,
  "Inazuma Eleven GO": 4,
  "Inazuma Eleven GO Chrono Stones": 5
};

  /**
   * Compara las características del intento con el personaje actual.
   * @param {Object} guess - Personaje adivinado
   * @returns {Array} Array de objetos con las características y sus colores correspondientes
   */
  const compararCaracteristicas = (guess) => {
  const keys = [
    "Hissatsu", "Name", "Team", "Position", "Element", "TP", "First Appear"
  ];
  
  return keys.map(key => {
    const valorReal = personajeActual[key] || "";
    const valorGuess = guess[key] || "";

    const valoresGuess = valorGuess.split("/");
    const valoresReal = valorReal.split("/");

    let color = '#7a1919';
    let arrow = null;

    if (key === "Hissatsu") {
      // Coincidencia exacta
      if (valorGuess === valorReal) {
        color = "green";
      }
    } else if (key === "Name") {
      // Compara múltiples usuarios (User/s)
      const todosCoinciden = valoresGuess.every(v => valoresReal.includes(v));
      const algunoCoincide = valoresGuess.some(v => valoresReal.includes(v));

      if (todosCoinciden && valoresGuess.length === valoresReal.length) {
        color = "green";
      } else if (algunoCoincide) {
        color = "#c0710a";
      }
    } else if (key === "First Appear" && valorReal && valorGuess) {
      // Comparar el orden de aparición de juegos
      const realGameOrder = gameOrder[valorReal.trim()] || 0;
      const guessGameOrder = gameOrder[valorGuess.trim()] || 0;

      if (valorGuess === valorReal) {
        color = "green";
      } else if (guessGameOrder > realGameOrder) {
        arrow = "↓";
      } else if (guessGameOrder < realGameOrder) {
        arrow = "↑";
      }
    } else if (key === "TP" && valorReal && valorGuess) {
      const tpReal = parseInt(valorReal) || 0;
      const tpGuess = parseInt(valorGuess) || 0;

      if (tpGuess === tpReal) {
        color = "green";
      } else if (tpGuess > tpReal) {
        arrow = "↓";
      } else if (tpGuess < tpReal) {
        arrow = "↑";
      }
    }else if (valorGuess === valorReal) {
      color = "green";
    } else if (valoresGuess.some(v => valoresReal.includes(v))) {
      color = "#c0710a";
    }

    return { key, valor: valorGuess, color, arrow };
  });
};


  /**
   * Maneja el intento de adivinar el personaje.
   * @param {string} nombre - Nombre del personaje a adivinar (opcional, usa el input por defecto)
   */
  const handleGuess = (nombre = input) => {
  const clavesMostradas = [
  "Hissatsu", "Name", "Team", "Position", "Element","TP", "First Appear"
];
  
  const acierto = clavesMostradas.map(key => ({
    key,
    valor: personajeActual[key],
    color: "green",
  }));
    if (!personajeActual || partidaTerminada) return;

    if (!nombre.trim()) {
      //setMensaje("❌ Please enter a player's name.");
      return;
    }
  
    const guess = personajes.find(p => 
  p.Hissatsu.toLowerCase() === nombre.toLowerCase()
  );
    if (!guess) {
      //setMensaje("❌ That player is not on the database.");
      return;
    }
  
    if (intentosPrevios.has(guess.Hissatsu)) {
      setMensaje("⚠️ This technique was already tried");
      return;
    }
  
    const nuevosIntentos = new Set(intentosPrevios);
    nuevosIntentos.add(guess.Hissatsu);
    setIntentosPrevios(nuevosIntentos);
    if (guess.Hissatsu.toLowerCase() === personajeActual.Hissatsu.toLowerCase()) {
      setAttempts(historial.length + 1);
      setShowVictory(true);
      startCountdown(); 
      const stateToSave = {
        personajeActual,
        historial,
        intentosPrevios: Array.from(intentosPrevios),
        partidaTerminada,
        pistaEquipo,
        celdasVisibles: Array.from(celdasVisibles),
        useJapanese // Guardar el estado del idioma
      };
      const newStreak = winStreak + 1;
      setWinStreak(newStreak);
      localStorage.setItem('inazumadle_hissatsu_winStreak', newStreak.toString());
      saveGameState(stateToSave);
      const colors = [
        '#FFD700', // Oro
        '#FFA500', // Naranja
        '#FF6347', // Tomate
        '#FF4500', // Naranja rojizo
        '#FF8C00'  // Naranja oscuro
      ];
      const PARTICLE_COUNT = 120;
      const newTrophies = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
        emoji: ['🏆', '🎖️', '🥇', '🏅', '⭐'][Math.floor(Math.random() * 5)],
        size: Math.random() * 50 + 40,
        color: colors[Math.floor(Math.random() * colors.length)],
        id: Math.random().toString(36).substr(2, 9)
      }));
  
      setTrophies(newTrophies);
      setShowConfetti(true);
      setPartidaTerminada(true);
      setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
    
      setHistorial([...historial, acierto]);
    } else {
      setHistorial([...historial, compararCaracteristicas(guess)]);
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      localStorage.setItem('inazumadle_hissatsu_attempts', newAttempts.toString());
      
      // Verificar si alcanzó el límite
      /*if (newAttempts >= 7 && !partidaTerminada) {
        const PARTICLE_COUNT = 60;
        const newTrophies = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
          emoji: '❌',
          size: Math.random() * 50 + 40,
          color: '#ff0000',
          id: Math.random().toString(36).substr(2, 9)
        }));
        
        setTrophies(newTrophies);
        setShowConfetti(true);
        setPartidaTerminada(true);
        setShowVictory(true);
      }*/
    }
      animarCeldas(historial.length);
      setInput("");
    setSugerencias([]);
  };

  /**
   * Animación de las celdas de la tabla.
   * @param {number} filaIndex - Índice de la fila a animar
   */
  const animarCeldas = (filaIndex) => {
    const duracionAnimacion = 500;
    const celdasPorFila = 8;
      setCeldasAnimadas(prev => prev.filter(celda => celda.fila !== filaIndex));
  
    for (let i = 0; i < celdasPorFila; i++) {
      setTimeout(() => {
        const idCelda = `${filaIndex}-${i}`;
        if (!celdasVisibles.has(idCelda)) {
          setCeldasAnimadas(prev => [...prev, { fila: filaIndex, celda: i }]);
          setTimeout(() => {
            setCeldasVisibles(prev => new Set(prev).add(idCelda));
          }, duracionAnimacion);
        }
      }, i * duracionAnimacion);
    }
  };

  /**
   * Revela la pista del equipo después de 5 intentos.
   */
  const revelarPistaEquipo = () => {
    if (historial.length >= 5) {
      setPistaEquipo(personajeActual.Team);
      setPistaMostrada(true);
    }
  };

  const formatImageName = (name) => {
    return name.toLowerCase().replace(/ /g, '_');
  };

  return (
    <div className="app-container">
    <div className="p-5 text-center">
    <div className="p-5 text-center">
  {/* Contenedor para el logo y las imágenes laterales */}
  <div className="logo-container">
    {/* Imagen izquierda - Modo Endless */}
    <div className="side-column left-buttons">
    <Link to="/" id="first-link">
      <img 
        src="/images/classic.png" 
        alt="Classic Mode" 
        id="classic" 
        className="side-image"
      />
    </Link>

    <Link to="/endlessmode" id="second-link">
      <img 
        src="/images/endless.png" 
        alt="Endless Mode" 
        id="endless" 
        className="side-image"
      />
    </Link>
    </div>
    {/* Logo principal */}
    <img src={logo} alt="InazumaDle Logo" className="Logo" />
    <div className="side-column right-buttons">
    <Link to="/easymode" id="third-link">
      <img 
        src="/images/easy.png" 
        alt="Easy Mode" 
        id="easy" 
        className="side-image"
      />
    </Link>
    {/* Imagen derecha - Modo Hard */}
    <Link to="/hardmode" id="fourth-link">
      <img 
        src="/images/hard2.png" 
        alt="Hard Mode" 
        id="hard" 
        className="side-image"
      />
    </Link>
    </div>
  </div>

  {/* Resto de tu código... */}
</div>
      <h2 className="classic-title">{t("⚡Hissatsu Mode⚡", "⚡Modo Supertécnica⚡", "⚡Mode Supertechnique⚡")}</h2>
      {/* Input de búsqueda con autocompletado */}
        <div className="search-group">  
            <img 
        src="/markevans.png" 
        alt="Mark" 
        className="Mark" 
      />
      {/* Input de búsqueda con autocompletado */}
      <div className="contenedor-buscador">
        <input
          ref={inputRef}
          //style={{ width: "340px" }}  // Ancho personalizado
          className="InputBarraHissatsu"
          value={input}
          onChange={handleInputChange}
          placeholder={t("Guess the hissatsu...", "Adivina la supertécnica...", "Devine la supertechnique...")}
          disabled={partidaTerminada}
        />

        {sugerencias.length > 0 && (
        <div ref={menuRef} className="menu-desplegable-hissatsu">
          {sugerencias.map((sugerencia, index) => (
            <div
              key={index}
              className="sugerencia"
              onClick={() => seleccionarSugerencia(sugerencia.originalName)}
            >
              <img
                src={sugerencia.image}
                alt={sugerencia.name}
                className="imagen-hissatsu"
              />
              <span className="texto-sugerencia">{sugerencia.name}</span>
            </div>
          ))}
        </div>
      )}
      </div>
        </div>
          <div className="guess-controls">
      <div className="language-switch">
              <span 
        id="english-flag"
        className={`flag english-flag ${useJapanese === 'english' ? 'active' : ''}`} 
        onClick={() => {
          setUseJapanese('english');
          localStorage.setItem('inazumadle_languagePreference', 'english');
        }}
      >
        <img src="/images/earth-globe.png" alt="English" title="Dub Names" />
      </span>

      <span 
        id="spanish-flag"
        className={`flag spanish-flag ${useJapanese === 'spanish' ? 'active' : ''}`} 
        onClick={() => {
          setUseJapanese('spanish');
          localStorage.setItem('inazumadle_languagePreference', 'spanish');
        }}
      >
        <img src="/images/sp-flag.png" alt="Español" title="Español" />
      </span>

        <span 
        id="french-flag"
        className={`flag french-flag ${useJapanese === 'french' ? 'active' : ''}`} 
        onClick={() => {
          setUseJapanese('french');
          localStorage.setItem('inazumadle_languagePreference', 'french');
        }}
      >
        <img src="/images/fr-flag.png" alt="Français" title="Français" />
      </span>

      <span 
        id="japanese-flag"
        className={`flag japanese-flag ${useJapanese === 'japanese' ? 'active' : ''}`} 
        onClick={() => {
          setUseJapanese('japanese');
          localStorage.setItem('inazumadle_languagePreference', 'japanese');
        }}
      >
        <img src="/images/jp-flag.png" alt="Japanese" title="Japanese Names" />
      </span>
      </div>
      
      <button
        className="play-again-button"
        onClick={() => handleGuess()}
        disabled={partidaTerminada}
      >
        {/*{t("Guess", "Adivinar","Deviner")}*/}
        {t("Guess", "Adivinar", "Deviner")}
      </button>
      </div>

      {/* Pista del equipo */}
      <div className="mt-4 contenedor-pista-hissatsu">
        <button
        className={`p-2 rounded ${historial.length >= 5 && !partidaTerminada && !pistaMostrada ? "bg-green-500 text-white" : "bg-gray-400 cursor-not-allowed"}`}
        id="pista-button"
        onClick={revelarPistaEquipo}
        disabled={historial.length < 5 || partidaTerminada || pistaMostrada}
      >
        {historial.length < 5
          ? t(
              `Player's team hint (You need ${5 - historial.length} more tries)`,
              `Pista del equipo (necesitas ${5 - historial.length} intentos más)`,
              `Indice sur l'équipe du joueur (il te reste encore ${5 - historial.length} essais)`
            )
          : pistaMostrada
            ? t(
                "Player's team hint revealed",
                "Pista del equipo revelada",
                "Indice sur l'équipe du joueur révélé"
              )
            : t(
                "Player's team hint",
                "Pista del equipo",
                "Indice sur l'équipe du joueur"
              )
        }
      </button>
        {pistaEquipo && (
          <p className="mt-2 text-lg font-bold pista-texto">
          {t("Team:", "Equipo:", "Équipe :")}{" "}
          {useJapanese === 'japanese' && personajeActual['Japanese Team']
            ? personajeActual['Japanese Team']
            : useJapanese === 'spanish' && personajeActual['Spanish Team']
              ? personajeActual['Spanish Team']
              : useJapanese === 'french' && personajeActual['Frances Team']
                ? personajeActual['Frances Team']
                : pistaEquipo}
        </p>
        )}
              <p className="Note">
        {t(
          "Tip: Search by team name or player name to see all their hissatsus.",
          "Consejo: Busca por nombre de equipo o jugador para ver todas sus supertécnicas.",
          "Astuce : Cherche par nom d'équipe ou de joueur pour voir toutes leurs supertechniques."
        )}
      </p>

            <div className="stats-container-wrapper">
            <div className="beststreak-container">
              <div className="thunder-background"></div>
              <span className="streak-number">{record}</span>
              <span className="beststreak-tooltip">
                {t("Your current Record", "Tu récord actual", "Ton record actuel")}
              </span>
            </div>

            <div className="stats-container">
              {/* Contenedor de intentos */}
              <div className="attempts-container">
                {t("Tries:", "Intentos:", "Essais :")}{" "}
                <span className="attempts-number">{attempts}</span>
              </div>

              {/* Contenedor de streak */}
              <div className="streak-container">
                <div className="fire-background"></div>
                <span className="streak-number">{winStreak}</span>
                <span className="streak-tooltip">
                  {t("Your current Win Streak", "Tu racha de victorias", "Ta série de victoires actuelle")}
                </span>
              </div>
            </div>
          </div>    
</div>

      {/* Mensajes de feedback */}
      {mensaje && <p className="text-lg mt-4">{mensaje}</p>}

      {/* Tabla de intentos */}
      <h2 className="text-xl mt-6"></h2>
      <div className="mt-3 overflow-x-auto">
        <div className="tabla-wrapper">
        <table className="TablaHissatsu">
          <thead>
          <tr className="bg-gray-200">
            {[
              t("Hissatsu", "Hissatsu", "Hissatsu"),
              t("User", "Usuario", "Joueur"),
              t("Team", "Equipo", "Équipe"),
              t("Type", "Tipo", "Type"),
              t("Element", "Elemento", "Élément"),
              "TP", // se mantiene igual
              t("First Appear", "1ª aparición", "1re apparition")
            ].map((header, i) => (
              <th key={i} className="border border-gray-400 p-2">{header}</th>
            ))}
          </tr>
        </thead>
          <tbody>
  {historial.slice().reverse().map((intento, idx) => (
    <tr key={idx} className="text-center">
      {intento.map((caracteristica, i) => (
        <td
          key={i}
          className={`p-2 text-white ${
            !celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) && 
            celdasAnimadas.some(celda => celda.fila === (historial.length - 1 - idx) && celda.celda === i)
              ? "flip-animation"
              : ""
          }`}
          style={{
            backgroundColor: caracteristica.color,
            opacity: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 1 : 0,
            visibility: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 'visible' : 'hidden',
            transform: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 'scale(1)' : 'scale(0.8)'
          }}
        >
          {caracteristica.key === "Hissatsu" ? (
            <div className="hissatsu-container">
              <img
                src={`/images/hissatsu/${caracteristica.valor.toLowerCase().replace(/ /g, "-")}.png`}
                alt={caracteristica.valor}
                className="ImagenIntentoHissatsu"
              />
            </div>
          ) : caracteristica.key === "Name" ? (
          <div className="users-container">
            {caracteristica.valor.split("/").map((nombre, index) => {
              const nombreLimpio = nombre.trim();

              const personaje = personajes.find(p => 
                p.Name === nombreLimpio || 
                (useJapanese && p["Japanese Name"] === nombreLimpio)
              );

              const nombreArchivo = (personaje?.Name || nombreLimpio)
                .toLowerCase()
                .replace(/ /g, "-");

              return (
                <img
                  key={index}
                  src={`/images/jugadores/${nombreArchivo}.png`}
                  alt={useJapanese
                    ? personaje?.["Japanese Name"] || nombreLimpio
                    : nombreLimpio
                  }
                  className="ImagenIntento"
                />
              );
            })}
          </div>
          ) : caracteristica.key === "Team" ? (
            <div className="team-cell">
              {(
                personajes.find(p => p.Name === historial[historial.length - 1 - idx][1]?.valor)?.['Team']
                || caracteristica.valor
              ).split(/(?<!\s)\/(?!\s)/).map((equipo, index) => {
                const personaje = personajes.find(p => p.Name === historial[historial.length - 1 - idx][1]?.valor);
                const firstAppear = personaje?.["First Appear"];

                const esRaimon = equipo.trim() === "Raimon";
                const esRaimonClasico = firstAppear === "Inazuma Eleven 1" 
                  || firstAppear === "Inazuma Eleven 2"
                  || firstAppear === "Inazuma Eleven 3";

                const nombreEquipo = esRaimon
                  ? esRaimonClasico ? "raimon" : "raimon2"
                  : equipo.trim().toLowerCase().replace(/ /g, "-");

                let tooltip;
                if (useJapanese === 'japanese') {
                  tooltip = personaje?.['Japanese Team']?.split(/(?<!\s)\/(?!\s)/)[index]?.trim() || equipo.trim();
                } else if (useJapanese === 'spanish') {
                  tooltip = personaje?.['Spanish Team']?.split(/(?<!\s)\/(?!\s)/)[index]?.trim() || equipo.trim();
                } else if (useJapanese === 'french') {
                  tooltip = personaje?.['Frances Team']?.split(/(?<!\s)\/(?!\s)/)[index]?.trim() || equipo.trim();
                } else {
                  tooltip = personaje?.['Team']?.split(/(?<!\s)\/(?!\s)/)[index]?.trim() || equipo.trim();
                }


                return (
                  <div className="equipo-tooltip-container" key={index}>
                    <img
                      src={`/images/equipos/${nombreEquipo}.webp?v=1`}
                      alt={equipo.trim()}
                      className="equipo-imagen"
                    />
                    <div className="equipo-tooltip">{tooltip}</div>
                  </div>
                );
              })}
            </div>
          ) : caracteristica.key === "Element" ? (
            <div className="elements-container">
              {caracteristica.valor.split('/').map((element, index) => (
                <div key={index} className="element-cell">
                  <img 
                    src={`/${element.trim().toLowerCase()}.png`} 
                    alt={element.trim()}
                    className="element-image"
                  />
                </div>
              ))}
            </div>
            ) : caracteristica.key === "TP" ? (
            <div className="tp-container">
              <span className="tp-value">
                {caracteristica.valor}
              </span>
              {caracteristica.arrow && (
                <span className="tp-arrow">
                  {caracteristica.arrow}
                </span>
              )}
            </div>
          ) : caracteristica.key === "Position" ? (
            <div className="positions-container">
            {caracteristica.valor.split('/').map((position, index) => (
              <div key={index} className="position-cell">
                <img 
                  src={`/${position.trim().toLowerCase()}${useJapanese === 'spanish' ? '2' : useJapanese === 'french' ? '3' : ''}.png`} 
                  alt={position.trim()}
                  className="position-image"
                />
              </div>
            ))}
          </div>
          ) : caracteristica.key === "First Appear" ? (
            <div className="appear-container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <img 
                src={`/${formatImageName(caracteristica.valor)}.png`}
                alt={`${caracteristica.valor}`}
                className="appear-image"
              />
              {caracteristica.arrow && (
                <span style={{ 
                  color: 'white', 
                  fontSize: "200%",
                  marginLeft: '5px',
                  lineHeight: '1',
                  textShadow: `
                    0 0 4px black,
                    0 0 4px black,
                    0 0 4px black,
                    0 0 4px black
                  `,
                  fontWeight: 'bold'
                }}>
                  {caracteristica.arrow}
                </span>
              )}
            </div>
          ) : (
            caracteristica.valor
          )}
        </td>
      ))}
    </tr>
  ))}
</tbody>

        </table>
        </div>
      </div>
      {showVictory && (
  <div ref={victoryRef} className="victory-message">
    <div className="victory-title-container">
          <img src="/images/beta-left.png" alt="Celebration" className="victory-side-image" />
          <h2 className="game-over-text">{t("YOU WIN!", "¡VICTORIA!", "Victoire!")}</h2>
          <img src="/images/beta-right.png" alt="Celebration" className="victory-side-image" />
    </div>
    
    <div className="player-info">
      <img 
        src={`/images/hissatsu/${personajeActual.Hissatsu.toLowerCase().replace(/ /g, "-")}.png`} 
        alt={personajeActual.Hissatsu}
        className="victory-hissatsu-image"
      />
      <h3>
      {useJapanese === 'japanese' && personajeActual['Japanese Hissatsu']
  ? personajeActual['Japanese Hissatsu']
  : useJapanese === 'spanish' && personajeActual['Spanish Hissatsu']
    ? personajeActual['Spanish Hissatsu']
    : useJapanese === 'french' && personajeActual['Frances Hissatsu']
      ? personajeActual['Frances Hissatsu']
      : personajeActual.Hissatsu}
    </h3>

    <p>
      {t("User:", "Usuario:", "Joueur:")}{" "}
      {useJapanese === 'japanese' && personajeActual['Japanese Name']
        ? personajeActual['Japanese Name']
        : useJapanese === 'spanish' && personajeActual['Spanish Name']
          ? personajeActual['Spanish Name']
          : useJapanese === 'french' && personajeActual['Frances Name']
            ? personajeActual['Frances Name']
            : personajeActual.Name}
    </p>
    </div>
    
    <div className="victory-stats">
      <p>{t("You guessed it in:", "Lo adivinaste en:", "Tu as trouvé en :")} <strong>{attempts} {t("tries", "intentos", "essais")}</strong></p>
      <p>{t("Next hissatsu in:", "Siguiente supertécnica en:", "Prochaine supertechnique dans :")} <strong>{countdown}</strong></p>
    </div>
    
    <div className="victory-actions">
      <a 
        href={`https://x.com/intent/tweet?text=${encodeURIComponent(generateTweetMessage())}`} 
        target="_blank" 
        rel="noopener noreferrer"
        className="tweet-button"
      >
        {t("Share on X", "Compartir en X", "Partager sur X")}
      </a>

      
    </div>
  </div>
)}
</div>
        <footer className="footer-hissatsu">
  <div className="footer-content">
    <p>InazumaDle.com — 2025</p>
    <p>{t("Level-5 does not endorse or sponsor this project.", "Level-5 no avala ni patrocina este proyecto.","Projet sans lien avec Level-5")}</p>

    <div className="footer-links">
      <Link to="/privacy" className="footer-link">{t("Privacy Policy", "Política de Privacidad")}</Link>
      <span>•</span>
      <Link to="/about" className="footer-link">{t("About Me", "Sobre mí")}</Link>
      <span>•</span>
      <Link to="/thanks" className="footer-link">{t("Special Thanks","Agradecimientos")}</Link>
    </div>

    {/* Segunda fila: Iconos Ko-Fi y Twitter */}
    <div className="footer-kofi">
      <a href="https://ko-fi.com/inazumadle" target="_blank" rel="noopener noreferrer">
        <img src="/images/ko-fi-icon.png" alt="Support me on Ko-fi" className="kofi-icon"/>
      </a>
      <a href="https://x.com/Inazumadle" target="_blank" rel="noopener noreferrer">
        <img src="/images/x.png" alt="Follow me on Twitter" className="twitter-icon" />
      </a>
    </div>
  </div>
</footer>
      {showConfetti && <TrophyParticles trophies={trophies} physics={physics} />}
    </div>
  );
  
}

const GravityTrophy = ({ emoji, size, color, onRemove, physics }) => {
  const [position, setPosition] = useState({
    x: Math.random() > 0.5 ? -100 : window.innerWidth + 100,
    y: Math.random() * window.innerHeight * 0.3
  });
  const isMobile = window.innerWidth < 768;

  const [velocity, setVelocity] = useState({
    x: (Math.random() > 0.5 ? 1 : -1) * (Math.random() * (isMobile ? 8 : 15) + (isMobile ? 6 : 10)),
    y: Math.random() * (isMobile ? -15 : -20) - (isMobile ? 7 : 10)
  });
  const ref = useRef();

  useEffect(() => {
    let animationId;
    let alive = true;

    const updatePosition = () => {
      if (!alive) return;

      setVelocity(prev => {
        let newY = prev.y + physics.gravity;
        if (newY > physics.terminalVelocity) newY = physics.terminalVelocity;
        return {
          x: prev.x * physics.friction,
          y: newY
        };
      });

      setPosition(prev => {
        const newPos = {
          x: prev.x + velocity.x,
          y: prev.y + velocity.y
        };

        if (newPos.y > window.innerHeight + 100 || 
            newPos.x < -200 || 
            newPos.x > window.innerWidth + 200) {
          setTimeout(() => onRemove(), 0);
          return prev;
        }

        return newPos;
      });

      animationId = requestAnimationFrame(updatePosition);
    };

    animationId = requestAnimationFrame(updatePosition);

    return () => {
      alive = false;
      cancelAnimationFrame(animationId);
    };
  }, [velocity.x, velocity.y, onRemove]);

  return (
    <div
      ref={ref}
      className="gravity-trophy"
      style={{
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        fontSize: `${size}px`,
        color: color,
        transform: `rotate(${position.x * 0.5}deg)`,
        transition: 'transform 0.1s ease-out',
        zIndex: 1000,
        pointerEvents: 'none',
        userSelect: 'none',
        textShadow: `0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px ${color}`,
        filter: 'saturate(2.5) brightness(1.2)'
      }}
    >
      {emoji}
    </div>
  );
};

const TrophyParticles = ({ trophies, physics }) => {
  const [activeTrophies, setActiveTrophies] = useState([]);

  useEffect(() => {
    if (trophies.length > 0) {
      setActiveTrophies(prev => [
        ...prev,
        ...trophies.map(t => ({
          ...t,
          id: Math.random().toString(36).substr(2, 9)
        }))
      ]);
    }
  }, [trophies]);

  const removeTrophy = (id) => {
    setActiveTrophies(prev => prev.filter(t => t.id !== id));
  };

  return (
    <>
      {activeTrophies.map(trophy => (
        <GravityTrophy
          key={trophy.id}
          emoji={trophy.emoji}
          size={trophy.size}
          color={trophy.color}
          onRemove={() => removeTrophy(trophy.id)}
          physics={physics} 
        />
      ))}
    </>
  );

};


export default InazumaDle;